import { InjectionToken, Injectable, inject } from '@angular/core';

import { SentryOptions } from '../../interfaces';
import { noop } from '../../utils';

export const CAPTURE_MESSAGE: InjectionToken<SentryLogger> = new InjectionToken('sentryCaptureMessage');

@Injectable({ providedIn: 'root' })
export class SentryLogger {
  private captureMessage: Function = inject<Function>(CAPTURE_MESSAGE, { optional: true }) ?? noop;

  error = (message: string, extra?: unknown): void =>
    this.log(message, { level: 'error', extra: this.normalizeExtra(extra) });
  info = (message: string, extra?: unknown): void =>
    this.log(message, { level: 'info', extra: this.normalizeExtra(extra) });
  warn = (message: string, extra?: unknown): void =>
    this.log(message, { level: 'warning', extra: this.normalizeExtra(extra) });

  protected setCaptureMessage(_captureMessage: Function): void {
    this.captureMessage = _captureMessage;
  }

  private log(message: string, options: SentryOptions): void {
    this.captureMessage(message, options);
  }

  private normalizeExtra(extra?: unknown): Record<string, unknown> | undefined {
    if (extra === undefined) {
      return undefined;
    }
    return typeof extra === 'object' && extra !== null ? (extra as Record<string, unknown>) : { value: extra };
  }
}
